import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"

interface ScrapsState {
  scrapIds: { id: string; sentenceId: string }[] | null
  scrapCounts: Record<string, number>
  addScrapId: (id: string, sentenceId: string) => void
  deleteScrapId: (id: string) => void
  setScraps: (ids: { id: string; sentenceId: string }[]) => void
  clear: () => void
  updateScrapCount: (sentenceId: string, count: number) => void
  getScrapCount: (
    sentenceId: string,
    defaultCount: number | null,
  ) => number | null
  isLoading: boolean
  setIsLoading: (loading: boolean) => void
  isScrap: (sentenceId: string) => boolean
}

export const useMyScrapsStore = create<ScrapsState>()(
  persist(
    (set, get) => ({
      scrapIds: null,
      scrapCounts: {},
      addScrapId: (id, sentenceId) =>
        set((state) => ({
          scrapIds: state.scrapIds
            ? state.scrapIds.find((scrap) => scrap.id === id)
              ? state.scrapIds
              : [...state.scrapIds, { id, sentenceId }]
            : [{ id, sentenceId }],
        })),
      deleteScrapId: (id) =>
        set((state) => ({
          scrapIds: state.scrapIds
            ? state.scrapIds.filter((scrap) => scrap.id !== id)
            : null,
        })),
      setScraps: (ids) => set({ scrapIds: ids }),
      clear: () => set({ scrapIds: null, scrapCounts: {} }),
      updateScrapCount: (sentenceId, count) =>
        set((state) => ({
          scrapCounts: { ...state.scrapCounts, [sentenceId]: count },
        })),
      getScrapCount: (sentenceId, defaultCount) => {
        const state = get()
        return state.scrapCounts.hasOwnProperty(sentenceId)
          ? state.scrapCounts[sentenceId]
          : defaultCount
      },
      isLoading: false,
      setIsLoading: (loading) => set({ isLoading: loading }),
      isScrap: (sentenceId) =>
        !!(
          typeof sentenceId === "string" &&
          get().scrapIds?.some((scrap) => scrap.sentenceId === sentenceId)
        ),
    }),
    {
      name: "my-scraps-storage",
      partialize: (state) => ({
        scrapIds: state.scrapIds,
        scrapCounts: state.scrapCounts,
      }),
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
